import { gql } from '@apollo/client';

const GET_THREAD = gql`
  query GetThread(
    $filter: ThreadArgsFilter!
    $limit: Int
    $offset: Int
    $sorter: ThreadArgsSorter
  ) {
    thread(filter: $filter, limit: $limit, offset: $offset, sorter: $sorter) {
      nodes {
        id
        description
        parentQuestionId
        isConfirmed
        isFollowUp
        editedAt
        createdBy {
          id
          firstName
          lastName
          email
          pictureURL
        }
        resources {
          id
          name
          type
          mimeType
        }
        readReceipts {
          user {
            id
            firstName
            lastName
            email
            pictureURL
          }
          readAt
        }
        createdAt
        updatedAt
      }
    }
  }
`;

export default GET_THREAD;
